import {styled, Slider as MuiSlider} from "@mui/material";

const CSlider = styled(MuiSlider)(({theme}) => ({
  width: "100%",
  color: "var(--text-primary)",
  height: "2px",

  "& .MuiSlider-rail": {
    backgroundColor: "var(--border-main-color)",
  },
  "& .MuiSlider-thumb": {
    borderRadius: "16px",
    width: "16px",
    height: "16px",
    border: "3px solid var(--text-primary)",
    backgroundColor: "#000",
  },
  "& .MuiSlider-mark": {
    width: "8px",
    height: "8px",
    borderRadius: "8px",
    border: "2px solid var(--border-main-color)",
    backgroundColor: "#252727",
  },
  "& .MuiSlider-markActive": {
    width: "8px",
    height: "8px",
    borderRadius: "8px",
    border: "2px solid var(--text-primary)",
    backgroundColor: "#FFF",
  },
}));

export default CSlider;
